export const INITIALIZE_ORDER = 'INITIALIZE_ORDER';
export const INITIALIZE_ORDER_SUCCESS = 'INITIALIZE_ORDER_SUCCESS';
export const INITIALIZE_ORDER_FAILURE = 'INITIALIZE_ORDER_FAILURE';

export const CREATE_ORDER = 'CREATE_ORDER';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const CLOSE_ALERT = 'CLOSE_ALERT';

export const ANSWER = 'ANSWER';
export const SET_ORDER_DESCRIPTION = 'SET_ORDER_DESCRIPTION';

export const SET_DEFAULTS = 'SET_DEFAULTS';
export const SET_INDICATOR_DEFAULTS = 'SET_INDICATOR_DEFAULTS';

export const TOGGLE_INDICATOR_WIZARD = 'TOGGLE_INDICATOR_WIZARD';

export const RESET_ERROR = 'RESET_ERROR';
